import { Box, useTheme } from '@mui/material'

const ImportStepIcon = ({ active, completed, icon }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        borderRadius: '50%',
        border: `1px solid ${active || completed ? theme.palette.primary.main : '#DADDE3'}`,
        backgroundColor: completed ? theme.palette.primary.main : theme.palette.common.white,
        color: completed ? theme.palette.common.white : active ? theme.palette.primary.main : '#989898',
        fontSize: 11,
        fontWeight: 500
      }}>
      {completed ? <i className="fa-regular fa-check" /> : icon}
    </Box>
  )
}

export default ImportStepIcon
